import { render, staticRenderFns } from "./PromotionalCarousel.vue?vue&type=template&id=0d9318ed&scoped=true"
import script from "./PromotionalCarousel.vue?vue&type=script&lang=js"
export * from "./PromotionalCarousel.vue?vue&type=script&lang=js"
import style0 from "./PromotionalCarousel.vue?vue&type=style&index=0&id=0d9318ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9318ed",
  null
  
)

export default component.exports